export const initNavigation = function (config) {

  // Handle white background class, if first section element is iamge-hero
  if ($('main > section.flixx_hero').length > 0) {
    $('body').addClass('has-hero');

    // Move breadcrumb section after the last flixx_hero section
    const $heroSections = $('section.flixx_hero');
    const $breadcrumb = $('section.flixx_breadcrumb').first();
    if ($heroSections.length > 0 && $breadcrumb.length > 0) {
      const $lastHero = $heroSections.last();
      $breadcrumb.insertAfter($lastHero);
    }
  }

  $('li.dropdown > a.nav-link div.toggle-nav').on('click', function (e) {
    e.preventDefault()
    let $parentLi = $(this).closest('li.dropdown');

    console.log($parentLi);

    if ($parentLi.children('a').hasClass('show')) {
      $parentLi.children('a').first().removeClass('show');
      $parentLi.children('div').first().removeClass('show');
    } else {
      $parentLi.children('a').first().addClass('show');
      $parentLi.children('div').first().addClass('show');
    }
  });

  //megamenu show column 2
  $('li.has-submenu > a.nav-link').on('click mouseover', function (e) {
    //e.preventDefault();
    let $submenuSource = $(this).siblings('div');
    let $submenuTarget = $(this).closest('.megamenu').find('.submenu-target-l2');
    $(this).closest('.megamenu').find('.submenu-target-l3').empty();
    $submenuTarget.html($submenuSource.html());
  });


}
